import { Box, BoxProps } from "@mui/material";
import React from "react";

const BoxWrapper: React.ForwardRefExoticComponent<Omit<BoxProps, "ref"> & React.RefAttributes<any>> =
  React.forwardRef<any, BoxProps>((props, ref) => <Box {...props} ref={ref} />);

export default BoxWrapper;
